import React, { memo, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CalculatorPrice from 'components/CalculatorPrice';
import InsuranceBuyingFlowFormDrawer from 'components/InsuranceBuyingFlowFormDrawer';
import useCarAppaCalculationContext from 'features/common/calculators/car/appa/hooks/car-app-calculation-context.hook';
import CarAppaCalculationForm from 'features/common/calculators/car/appa/components/CarAppaCalculationForm';
import appaNotOnlinePrice from 'common/utils/appa-not-online-price.utils';
import {
  AppRoutePath,
  InsuranceBuyingStepRoute,
} from 'common/enums/app-route-path.enum';

function AppaBuyingCalculator() {
  const { form, price, isLoading } = useCarAppaCalculationContext();
  const navigate = useNavigate();
  const location = useLocation();

  const onHandleNavigation = useCallback(() => {
    navigate(
      `/insurances/${AppRoutePath.CAR_INSURANCES}/${AppRoutePath.CAR_APPA}/buy/${InsuranceBuyingStepRoute.DETAILS}`,
      {
        state: {
          ...location.state,
        },
      }
    );
  }, [location.state, navigate]);

  return (
    <InsuranceBuyingFlowFormDrawer
      form={
        <CarAppaCalculationForm
          initialState={form || undefined}
          onBuy={onHandleNavigation}
        />
      }
      details={
        <CalculatorPrice
          price={price}
          isLoading={isLoading}
          notOnlinePrice={appaNotOnlinePrice(price)}
        />
      }
    />
  );
}

export default memo(AppaBuyingCalculator);
